import React, { useState, useEffect } from "react";
import "./index.scss";
// 1) Import i18n from react-i18next
import { useTranslation } from "react-i18next";

const CustomCard = ({
  type = "fund",
  fund,
  onAmountChange,
  initialAmount,
  dayNumber,
  date,
  amount,
  donationAmount,
  disabled = false,
  currentTotal,
  template,
  isFriday = false,
  selected = false,
  onCheckboxChange,
  isFirstFriday = false
}) => {
  // 2) Destructure t from useTranslation
  const { t } = useTranslation();

  const [isActive, setIsActive] = useState(false);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (type === "fund" && !isFriday) {
      if (initialAmount !== undefined && initialAmount !== 0) {
        setValue(initialAmount.toString());
      } else {
        setValue("");
      }
    } else if (type === "scheduleDay") {
      if (amount !== undefined && amount !== 0) {
        setValue(amount);
      } else {
        setValue("");
      }
    }
  }, [initialAmount, amount, type, isFriday]);

  const handleInputChange = (e) => {
    const numericValue =
      parseInt(e.target.value.replace(/[^0-9]/g, ""), 10) || 0;
    setValue(numericValue);
    if (onAmountChange) {
      if (type === "fund") {
        onAmountChange(fund.fundId, numericValue);
      } else {
        onAmountChange(numericValue);
      }
    }
  };

  const handleBlur = () => {
    setIsActive(false);
  };

  const handleCheckboxChangeInternal = (e) => {
    if (onCheckboxChange) {
      onCheckboxChange(fund.fundId, e.target.checked);
    }
  };

  // 3) We'll call a helper to get the localized info text
  const infoText =
    fund?.info && fund?.info.length > 0
      ? fund?.info
      : hardcodedCardInfo(fund?.name, t);

  return (
    <div
      className={`card-container ${isActive ? "active" : ""}`}
      style={type === "fund" ? { minHeight: "250px" } : {}}
    >
      {type === "fund" ? (
        <>
          <div className="card-top-container">
            <div className="icon-container">
              <div
                className="icon"
                dangerouslySetInnerHTML={{ __html: fund.iconSVGCode }}
              />
            </div>

            <h3 className="card-title">{fund.name}</h3>
            <p className="card-description">{infoText}</p>
          </div>
          {isFriday ? (
            <div className="checkbox-wrapper">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={selected}
                  onChange={handleCheckboxChangeInternal}
                />
                <span className="checkmark"></span>
                <span className="checkbox-text">
                  {t("customCardSelectCause")}
                </span>
              </label>
            </div>
          ) : (
            <div className="input-wrapper">
              <span
                className={`dollar-prefix ${
                  Number(value) > 0 ? "has-value" : ""
                }`}
              >
                $
              </span>
              <input
                type="text"
                className="card-input"
                placeholder="0.00"
                value={value}
                onChange={handleInputChange}
                onFocus={() => setIsActive(true)}
                onBlur={handleBlur}
                disabled={disabled || isFriday}
              />
            </div>
          )}
        </>
      ) : (
        <>
          <div>
            <div className="day-number-container">
              {template?.toLowerCase().includes("ramadan") ? `Night ${dayNumber}` : dayNumber}
            </div>
            <div className="card-date">{date}</div>
          </div>
          <div className="input-wrapper">
            <span
              className={`dollar-prefix ${
                Number(value) > 0 ? "has-value" : ""
              }`}
            >
              $
            </span>
            <input
              type="text"
              className="card-input"
              placeholder="0.00"
              value={value}
              onChange={handleInputChange}
              onFocus={() => setIsActive(true)}
              onBlur={handleBlur}
              disabled={disabled}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CustomCard;

/* 
  5) We now pass 't' into this helper, so we can localize
  all "hardcoded" strings using translation keys.
*/
const hardcodedCardInfo = (fundName, t) => {
  switch (fundName) {
    case "Zakat":
      return t("fundInfoZakat");
    case "Emergency Response":
      return t("fundInfoEmergencyResponse");
    case "OrphanKind":
      return t("fundInfoOrphanKind");
    case "Feed Our World":
      return t("fundInfoFeedOurWorld");
    case "Thirst Relief":
      return t("fundInfoThirstRelief");
    case "Where Most Needed/Sadaqah":
      return t("fundInfoWhereMostNeeded");
    default:
      return t("fundInfoNoInformation");
  }
};
